import dataFetcher from "./utils/dataFetcher.js";

function _validateResultFn(result) {
  if (result.id) {
    return true;
  } else {
    return false;
  }
}

function _getThemeData(fetchURL, fetchParams, cache_ttl_min) {
  var maxAgeMinute = cache_ttl_min;

  return dataFetcher
    .getCachedDataForURLParamsMaxAgeMinute(fetchURL, fetchParams, maxAgeMinute)
    .then(function(cachedResult) {
      if (cachedResult) {
        return cachedResult;
      } else {
        // cached not available so fetch from the network
        return dataFetcher.fetchThenValidateAndCache(
          fetchURL,
          fetchParams,
          _validateResultFn
        );
      }
    })
    .then(function(finalResult) {
      // doing what it should do
      if (!finalResult || finalResult === {}) {
        throw new Error("Theme not found");
      }
      return finalResult;
    })
    .catch(function(error) {
      console.warn(
        "themeDataProvider: Failed to get data for " + fetchURL + ", params = ",
        fetchParams,
        error
      );
      return null;
    });
}

const dataProvider = {
  validateResultFn: _validateResultFn,
  getThemeData: _getThemeData
};

export default dataProvider;
